"use client";

import { useAuth } from "@clerk/nextjs";
import { ConvexQueryCacheProvider } from "convex-helpers/react/cache/provider";
import { ConvexReactClient } from "convex/react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import type { ReactNode } from "react";
if (!process.env.NEXT_PUBLIC_CONVEX_URL) {
  throw new Error("Missing NEXT_PUBLIC_CONVEX_URL in your .env file");
}
const convex = new ConvexReactClient(process.env.NEXT_PUBLIC_CONVEX_URL);
export default function ConvexClientProvider({
  children
}: {
  children: ReactNode;
}) {
  return <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
      {/* Idle subscriptions expire after 5 minutes; retain at most 50 for instant revisits. */}
      <ConvexQueryCacheProvider maxIdleEntries={50}>{children}</ConvexQueryCacheProvider>
    </ConvexProviderWithClerk>;
}